export const welcomeJomatik = {
    welcomeToMurtfeldtAS: 'Welcome to Murtfeldt Additive Solutions.',
    dearJomatikCustomer: 'Dear Jomatik Customer,',
    happyToSeeYou:
        'we are happy to greet you at our new platform <span class="has-text-primary">www.murtfeldt-as.de</span>.',
    nameChange: 'becomes',
    everythingAsNormal: 'Despite our new Look everthing stays as normal:',
    sameTeam: 'same Team',
    sameService: 'same Service',
    sameLogin: 'Login with your usual JOMATIK - credentials.',
    discount:
        'As a welcome gift you\'ll receive a <span class="has-text-primary">{amount}%</span> discount by using the code <span class="has-text-info">{code}</span>.',
    thankYou:
        'Thank you for your loyalty,<br> Your Team at Murtfeldt Additive Solutions',
    marketPlaceNote:
        'We ask you to use our new platform <br/><span class="has-text-primary">murtfeldt-as.de</span> for future orders. However we will keep the Jomatik Marketplace online for while.',
    goToStart: 'Go to platform',
    goToMarketPlace: 'Go to JOMATIK Marketplace',
};
